import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import install from './install'
import 'bulma/css/bulma.css'
import VueCarousel from 'vue-carousel'
import VuejsClipper from 'vuejs-clipper'
import axios from 'axios'
import Vuex from 'vuex'
import VueClipboard from 'vue-clipboard2'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { firestorePlugin } from 'vuefire'

Vue.use(Datetime)
Vue.use(VueClipboard)
Vue.use(Vuex)
Vue.use(VuejsClipper)
Vue.use(axios)
Vue.use(VueCarousel)
Vue.use(install)
Vue.use(firestorePlugin)

firebase.initializeApp({
  apiKey: 'AIzaSyD7dfNnkcWBypvXwVTRmOYJQ972ezwFTCg',
  authDomain: 'tatami-87900.firebaseapp.com',
  databaseURL: 'https://tatami-87900.firebaseio.com',
  projectId: 'tatami-87900',
  storageBucket: 'tatami-87900.appspot.com',
  messagingSenderId: '956885288400',
  appId: '1:956885288400:web:4887bc29068dcf97bce5d5',
  measurementId: 'G-5EM1VSNMBV'
})

export const db = firebase.firestore()

Vue.prototype.$http = axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.config.devtools = process.env.NODE_ENV !== 'production'
let app = ''

if (!app) {
  app = new Vue({
    router,
    store,
    mounted () {
      AOS.init()
    },
    render: h => h(App)
  }).$mount('#app')
}
